import React from 'react';
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Info } from '@mui/icons-material';
import { formatMoney } from '../../../../../lib/functions/utils';
import { LightTooltip } from '../../../../../lib/designSystem/WhiteTooltip';

const useStyles = makeStyles(() => ({
  container: {
    maxWidth: '800px',
  },
  noPaddingMargin: {
    padding: '0p !important',
    margin: '0px',
  },
}));

const NotificationParametersConfiguration = (props: any) => {
  const { config, notifications, notificationId, setNotifications } = props;
  const classes = useStyles();

  const handleChange = (e: any) => {
    const newNotifications = notifications.map((notification: any) => {
      if (notification.id === notificationId) {
        const newConfig = notification.config.map((c: any) => {
          if (c.key === config.key) {
            return { ...c, value: e.target.value };
          }
          return c;
        });
        return { ...notification, config: newConfig };
      }
      return notification;
    });
    setNotifications(newNotifications);
  };

  const valueFormatter = (value: any) => {
    switch (config.type) {
      case 'money':
        return formatMoney(value);
      case 'boolean':
        return value === 'true' ? 'Sí' : 'No';
      default:
        return value;
    }
  };

  return (
    <div style={{ padding: '4px 0px' }}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '0px 0px 0px 36px',
        }}
      >
        <div>
          <LightTooltip
            title={
              <Typography variant="body1" style={{ padding: '8px' }}>
                {config.description}
              </Typography>
            }
          >
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Typography
                variant="body1"
                fontWeight={'bold'}
                marginRight={'4px'}
              >
                {config.name}
              </Typography>
              <Info style={{ fontSize: '14px', cursor: 'pointer' }} />
            </div>
          </LightTooltip>
        </div>
        <div>
          <FormControl
            margin="dense"
            fullWidth
            className={classes.noPaddingMargin}
          >
            <InputLabel id="filter-label">Parámetro</InputLabel>
            <Select
              sx={{
                '& .MuiSelect-select': {
                  paddingRight: 4,
                  paddingLeft: 2,
                  paddingTop: 2,
                  paddingBottom: 1,
                  margin: 0,
                  minWidth: '100px',
                },
              }}
              className={classes.noPaddingMargin}
              labelId="filter-label"
              id="Filtrar por estado"
              fullWidth
              margin="dense"
              value={config.value}
              onChange={(e) => handleChange(e)}
              label="Parámetro"
            >
              {config.values.map((x: any, index: any) => (
                <MenuItem key={index} value={x.value}>
                  {valueFormatter(x.value)}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
      </div>
    </div>
  );
};

export default NotificationParametersConfiguration;
